export default __webpack_public_path__ + "static/media/pagination_left_arrow.c9f2e5a9.svg";